import { ReactElement, useMemo } from 'react';
import { MapInfoContainer } from '../../styles';
import { buildHealthyInfo, buildInfoCardProps } from '~/pages/NewOverview/helpers/map';
import { InfoCard } from '../InfoCard';
import { UnitsInfo } from 'pages/NewOverview/contexts/HealthDataContext';
import { StateHint } from '../StateHint';
import { UnitHint } from '../UnitHint';

interface MapInfoProps {
  name: string | undefined;
  scope: 'state' | 'unit';
  unitsMap: Map<string, UnitsInfo>;
  selected: boolean;
  state?: string;
  unitInfo?: {id: number, city: string };
  onCloseInfoCard: () => void;
}

export function MapInfo({
  name,
  scope,
  unitsMap,
  unitInfo,
  selected,
  state,
  onCloseInfoCard,
}: Readonly<MapInfoProps>): ReactElement {
  const infoProps = useMemo(
    () => buildInfoCardProps(scope, buildHealthyInfo(scope, unitsMap, name, state, unitInfo?.id)),
    [name, scope, state, unitInfo, unitsMap],
  );

  const showStateHint = scope === 'state' && !name;
  const showUnitHint = scope === 'state' && selected;

  return (
    <MapInfoContainer>
      {showStateHint ? (<StateHint />) : (
        <>
          <InfoCard
            name={name ?? ''}
            onClose={onCloseInfoCard}
            scope={scope}
            type="health"
            {...infoProps}
            unitInfo={unitInfo}
          />
          {showUnitHint && (
            <UnitHint />
          )}
        </>
      )}
    </MapInfoContainer>
  );
}
